import ApplicationController from './application_controller'
import flatpickr from 'flatpickr'
import dayjs from 'dayjs'

export default class extends ApplicationController {

	static targets = [
		'input',
		'calendarContainer',
		'dateHintElement',
		'resetButton',
	]

	static values = {
		mode:                        { type: String,  default: 'single' },
		maxDate:                     { type: String,  default: null },
		minDate:                     { type: String,  default: null },
		inline:                      { type: Boolean, default: false },
		submitOnValueUpdate:         { type: Boolean, default: false },
		longDisplayFormat:           { type: Boolean, default: true },
		updateDateHintOnValueUpdate: { type: Boolean, default: true },
		enableDates:                 { type: Array, default: [] },
	}

	connect() {
		this.initFlatpickr()
		if (this.inputTarget.value) this.updateDateDisplayElement([], this.inputTarget.value, null)
		this.updateResetButton()
	}

	disconnect() {
		this.calendar.destroy()
	}

	initFlatpickr() {
		const flatpickrConfig = {
			dateFormat: 'Y-m-d',
			mode: this.modeValue,
			inline: this.inlineValue,
			maxDate: this.maxDateValue,
			minDate: this.minDateValue,
			position: 'below center',
			onValueUpdate: this.onValueUpdate,
		}

		if (this.inlineValue) flatpickrConfig.appendTo = this.calendarContainerTarget

		if (this.longDisplayFormatValue) {
			flatpickrConfig.altInput  = true
			flatpickrConfig.altFormat = "F j, Y"
		}

		if (this.enableDatesValue.length > 0) { flatpickrConfig.enable = this.enableDatesValue }

		this.calendar = flatpickr(this.inputTarget, flatpickrConfig)

		this.calendar.config.onClose.push(this.resetFlatpickrButtons)

		if (this.updateDateHintOnValueUpdateValue) {
			this.calendar.config.onChange.push(this.updateDateDisplayElement.bind(this))
		}

		if (this.submitOnValueUpdateValue) {
			this.calendar.config.onChange.push(this.submitOnValueUpdate)
		}
	}

	resetFlatpickrButtons() {
		for (const flatpickrButton of document.querySelectorAll("div[data-controller='flatpickr-button']")) {
			flatpickrButton.dispatchEvent(new CustomEvent('set-button-to-show'))
		}
	}

	updateDateDisplayElement(_selectedDates, dateStr, _instance) {
		if (this.calendar.config.mode == 'single') {
			if (this.hasDateHintElementTarget && dateStr && /^\d\d\d\d-\d\d-\d\d/.test(dateStr)) {
				const date = dayjs(dateStr)
				this.dateHintElementTarget.innerText = date.format("MMMM D, YYYY (ddd)")
			}
		} else if (this.calendar.config.mode == 'multiple') {
			if (this.hasDateHintElementTarget && dateStr && /^\d\d\d\d-\d\d-\d\d/.test(dateStr)) {
				const numberOfDays = dateStr.split(', ').length
				this.dateHintElementTarget.innerText = `${numberOfDays} Days Selected`
			}
		}
	}

	submitOnValueUpdate(_selectedDates, dateStr, instance) {
		if (dateStr && /^\d\d\d\d-\d\d-\d\d to \d\d\d\d-\d\d-\d\d$/.test(dateStr)) {
			instance.input.closest('form').requestSubmit()
		}
	}

	open() {
		this.calendar.open()
	}

	close() {
		this.calendar.close()
	}

	updateResetButton() {
		if (!this.hasResetButtonTarget) { return }

		if (this.inputTarget.value) {
			this.resetButtonTarget.classList.remove('d-none')
			this.calendar._input.classList.remove('rounded-end') // this is the flatpickr text input
		} else {
			this.resetButtonTarget.classList.add('d-none')
			this.calendar._input.classList.add('rounded-end') // this is the flatpickr text input
		}
	}

	resetFlatpickr() {
		this.inputTarget.value = null
		this.calendar.clear()
		if (this.submitOnValueUpdateValue) {
			this.element.closest('form').requestSubmit()
		}
	}

	changeMode(event) { this.updateMode(event.currentTarget.value) }

	updateMode(mode) {
		if (mode == 'single') {
			this.calendar.clear()
			this.dateHintElementTarget.innerText = 'No Date Selected'
		}

		this.calendar.config.mode = mode
	}

	setDateRange(event) {
		const dateString = event.currentTarget.dataset.dateRange
		if (dateString && /^\d\d\d\d-\d\d-\d\d to \d\d\d\d-\d\d-\d\d$/.test(dateString)) {
			this.calendar.setDate(dateString)
		}
	}
}

